import { render, staticRenderFns } from "./ResetEmail.vue?vue&type=template&id=fd69f182&"
import script from "./ResetEmail.vue?vue&type=script&lang=js&"
export * from "./ResetEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../i18n/translations/reset.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Ffrontend%2Fsrc%2Fpages%2FResetEmail.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports